import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';
import { smartReport } from '@/utils/metricHelper';

let __armorToken: string = ''
export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['infp'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'], channel: string }) {
    if (extra?.channel == '0' || extra?.channel == '1') {
        if (window?.AntiDevices) return;
        const { url } = data
        // 使用本地临时数据
        let armorToken = window?.localStorage?.getItem('armorToken') || ''
        window.__ArmorToken = armorToken
        window?.sessionStorage?.setItem('armorToken', armorToken)
        asyncLoadFile({
            label: 'script',
            attrs: {
                // async: 'true',
                src: url,
                crossorigin: 'anonymous'
            },
        })
            .then(() => {
                const armorToken = window?.AntiDevices?.getArmorToken()
                __armorToken = armorToken || ''
                if (armorToken) {
                    window.__ArmorToken = armorToken
                    window?.sessionStorage?.setItem('armorToken', armorToken)
                    window?.localStorage?.setItem('armorToken', armorToken)
                    smartReport({
                        metric_name: METRIC_NAME,
                        tags: { url, type: 'loadInfp' },
                        value: 1,
                        message: 'armorToken load success',
                    })
                }
            }).then(() => {
                monitorSingleJsLoadTime('infp', JS_SERVER_TYPE[extra.env][extra.server_type]);
            })
            .catch(error => {
                smartReport({
                    metric_name: METRIC_NAME,
                    tags: { url, type: 'loadInfpError' },
                    value: 1,
                    message: 'armorToken load error',
                    params: error
                })
            })
    }
}

export async function headerOpenController(self: XMLHttpRequest, url: string) {
    if (GlobalVariables.get(GLOBAL_VARIABLES.API_PATHS).some(path => url.includes(path))) {
        const at = window.__ArmorToken || window?.sessionStorage?.getItem('armorToken') || window?.localStorage?.getItem('armorToken') || ''
        self._customHeaders = {
            ...self._customHeaders,
            'armorToken': at
        };
    }
}

export async function headerSendController(self: XMLHttpRequest) {
    if (self?._customHeaders?.['armorToken']) {
        self.setRequestHeader('armorToken', self?._customHeaders?.['armorToken']);
    }
}

export async function provideArmorToken(d: { validate_channel: string }) {
    try {
        if (d.validate_channel == '0' || d.validate_channel == '1') {
            // pc pwa
            return __armorToken || ''
        }
        if (!window?.Wing) return ''
        const res = await window?.Wing?.postBridge('WingHeader/get') || {};
        const headers = res?.headers || {};
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadInfp', url: 'shein' },
            value: 1,
            message: 'armorToken load success',
        })
        return headers['armorToken'] || ''
    } catch (error) {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadInfpError', url: 'shein' },
            value: 1,
            message: 'armorToken load error',
            params: error
        })
    }
    return ''
}